import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';

import App from './App.vue';

// import './registerServiceWorker';

import axios from './modules/axios';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
// Vue.use(Vue2TouchEvents);
Vue.use(Vue2TouchEvents, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  touchHoldTolerance: 400,
  swipeTolerance: 30,
  longTapTimeInterval: 400,
});
axios.defaults.baseURL = process.env.VUE_APP_ORIGIN || window.location.origin;

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
}).$mount('#app');
